<template>
  <main class="gain-main">
    <!-- Background with coffee bean on the right (desktop) -->
    <div class="background-container background-desktop">
      <img 
        src="@/assets/img/KV_Fond_Dotation.jpg" 
        alt="Background" 
        class="background-image"
      />
    </div>
    
    <!-- Background with coffee bean centered (mobile) -->
    <div class="background-container background-mobile">
      <img 
        src="@/assets/img/KV_Fond.jpg" 
        alt="Background" 
        class="background-image"
      />
    </div>

    <!-- Legal text for mobile (below bean) -->
    <p class="legal-text-mobile">
      *Utilisable sur tout le site cartenoire.fr, -5€ à partir de 50€ d'achat, valable jusqu'au 31/12/2026
    </p>

    <!-- Main container -->
    <div class="container">
      <div class="content-wrapper">
        <!-- Left column: Text content centered -->
        <div class="left-column">
          <div class="text-content">
            <h1 class="title">BRAVO !</h1>
            
            <p class="subtitle">VOUS AVEZ GAGNÉ</p>

            <p class="prize-text">
              <span class="gold-text">UN CODE PROMO*</span> d'une valeur de 5 €<br/>
              à valoir sur cartenoire.fr
            </p>

            <!-- Golden ticket -->
            <div class="ticket">
              <span class="ticket-value">5 €</span>
            </div>

            <p class="email-notice">
              <span class="gold-text">Un email vient de vous être envoyé !</span><br/>
              Pensez à vérifier votre dossier «&nbsp;courrier indésirable&nbsp;»
            </p>

            <p class="legal-text">
              *Utilisable sur tout le site cartenoire.fr, -5€ à partir de 50€ d'achat, valable jusqu'au 31/12/2026
            </p>
          </div>
        </div>

        <!-- Right column: Space for coffee bean background -->
        <div class="right-column"></div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: "Gain3View",
  mounted() {
    // Mode test : désactiver la vérification si ?test=true
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get("test") === "true") {
      return;
    }

    // Vérifier que le résultat du jeu existe et correspond à un perdant (code promo)
    const gameResult = window.__gameResult;

    if (!gameResult || gameResult.status !== "PERD") {
      window.location.href = "/";
      return;
    }

    // Nettoyer la variable après utilisation
    delete window.__gameResult;
  },
};
</script>

<style scoped>
.gain-main {
  background-color: #000;
  color: white;
  position: relative;
  min-height: calc(100vh - 150px - 60px);
  display: flex;
  flex-direction: column;
}

.container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 clamp(20px, 5vw, 60px);
  position: relative;
  z-index: 10;
  width: 100%;
  flex: 1;
}

.background-container {
  position: absolute;
  top: 0;
  left: 0%;
  bottom: 5%;
  width: 100%;
  pointer-events: none;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  transition: all 0.3s ease;
}

.background-desktop {
  display: flex;
}

.background-mobile {
  display: none;
}

.background-image {
  width: auto;
  height: 110%;
  max-height: none;
  object-fit: cover;
  object-position: center;
  transition: all 0.3s ease;
}

.content-wrapper {
  display: grid;
  grid-template-columns: 1fr 1fr;
  min-height: calc(100vh - 150px - 60px);
  align-items: center;
  transition: all 0.3s ease;
}

.left-column {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: clamp(20px, 4vw, 40px) 0;
}

.text-content {
  text-align: center;
}

.title {
  font-family: var(--font-primary);
  font-size: 84px;
  font-weight: 900;
  line-height: 1.1;
  margin: 0 0 clamp(10px, 2vw, 20px) 0;
  color: white;
  text-transform: uppercase;
}

.subtitle {
  font-family: var(--font-primary);
  font-weight: 700;
  font-size: 34px;
  color: white;
  line-height: 1.1;
  margin: 0 0 10px 0;
  text-transform: uppercase;
}

.prize-text {
  font-family: var(--font-primary);
  font-weight: 500;
  font-size: 34px;
  color: white;
  line-height: 1.1;
  margin: 0 0 clamp(15px, 3vw, 30px) 0;
}

.gold-text {
  color: white;
  font-weight: 700;
}

.ticket {
  background: linear-gradient(135deg, #d4a855 0%, #f5d89a 25%, #d4a855 50%, #b8943e 75%, #d4a855 100%);
  border-radius: 8px;
  padding: clamp(20px, 3vw, 30px) clamp(50px, 8vw, 80px);
  display: inline-block;
  position: relative;
  margin: clamp(15px, 2vw, 20px) 0 clamp(20px, 4vw, 40px) 0;
  box-shadow: 0 4px 15px rgba(212, 168, 85, 0.3);
  transform: rotate(-5deg);
}

.ticket::before,
.ticket::after {
  content: '';
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: clamp(14px, 2vw, 20px);
  height: clamp(14px, 2vw, 20px);
  background-color: #000;
  border-radius: 50%;
}

.ticket::before {
  left: clamp(-7px, -1vw, -10px);
}

.ticket::after {
  right: clamp(-7px, -1vw, -10px);
}

.ticket-value {
  font-family: var(--font-primary);
  font-size: clamp(36px, 6vw, 60px);
  font-weight: 400;
  color: #1a1a1a;
}

.email-notice {
  font-family: var(--font-primary);
  font-weight: 500;
  font-size: 24px;
  color: white;
  line-height: 1.1;
  margin: 0 0 clamp(15px, 3vw, 30px) 0;
}

.legal-text {
  font-family: var(--font-primary);
  font-weight: 400;
  font-size: clamp(10px, 1.2vw, 12px);
  color: white;
  line-height: 1.1;
  margin: clamp(15px, 3vw, 30px) 0 0 0;
}

.legal-text-mobile {
  display: none;
  font-family: var(--font-primary);
  font-weight: 400;
  font-size: 11px;
  color: #888;
  line-height: 1.1;
  text-align: center;
  padding: 15px 20px;
  margin: 0;
}

.right-column {
  /* Space for coffee bean background */
}

/* Large screens (2K+) - limit background size */
@media (min-width: 1920px) {
  .background-image {
    height: auto;
    max-height: 700px;
  }
}

/* Tablet breakpoint */
@media (max-width: 1024px) {
  .content-wrapper {
    grid-template-columns: 1.2fr 0.8fr;
  }

  .background-container {
    width: 50%;
  }
}

/* Mobile/Tablet transition */
@media (max-width: 768px) {
  .gain-main {
    min-height: auto;
  }

  .content-wrapper {
    grid-template-columns: 1fr;
    min-height: auto;
  }

  .background-desktop {
    display: none;
  }

  .background-mobile {
    display: flex;
    position: relative;
    width: 100vw;
    margin-left: calc(-50vw + 50%);
    min-height: 320px;
    top: auto;
    right: auto;
    bottom: auto;
    order: 2;
    margin-top: 0;
    background-color: #000;
    justify-content: center;
    align-items: center;
    overflow: hidden;
  }

  .background-mobile .background-image {
    width: 160%;
    max-width: none;
    height: auto;
    min-height: 380px;
    object-fit: cover;
    object-position: center;
    margin-top: -40px;
  }

  .left-column {
    order: 1;
    padding: 30px 0 0 0;
  }

  .right-column {
    display: none;
  }

  .legal-text {
    display: none;
  }

  .legal-text-mobile {
    display: block;
    order: 3;
  }

  .container {
    order: 1;
  }
}

/* Small mobile */
@media (max-width: 480px) {
  .background-mobile {
    min-height: 320px;
  }

  .background-mobile .background-image {
    width: 170%;
    min-height: 320px;
  }

  .ticket {
    padding: 15px 40px;
  }

  .ticket::before,
  .ticket::after {
    width: 12px;
    height: 12px;
  }

  .ticket::before {
    left: -6px;
  }

  .ticket::after {
    right: -6px;
  }
}
</style>
